/**
 * Direct buy on landing-page product tiles — the Hotel FLGNTLT mechanic
 * (flgntlt-hotel-lp.js › kauf) without the tie to the Hotel page root, so other landing
 * pages can use it. First user: Race Different (snippets/flgntlt-race-lp-produkt.liquid).
 * The Hotel page keeps its own copy for now; moving it here is a separate, tested step.
 *
 * Markup contract (data attributes, not classes, so styling stays free):
 *   [data-lp-kauf]            one tile's buy box; data-lp-einzeln="<variantId>" = no picker
 *   [data-lp-kauf-start]      the "add to cart" button
 *   [data-lp-groessen]        size panel (hidden attribute toggles it)
 *   [data-lp-variante="<id>"] one size
 *   [data-lp-kauf-zu]         close button
 *   [data-lp-meldung]         status line (aria-live)
 *
 * No dependencies, no build step.
 */
(function () {
  'use strict';

  if (window.__flgntltLpKauf) return; // the section may render the script tag more than once
  window.__flgntltLpKauf = true;

  var kacheln = document.querySelectorAll('[data-lp-kauf]');
  if (!kacheln.length) return;

  var wurzelPfad = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function drawer() {
    return document.querySelector('cart-drawer');
  }

  /** Ask the drawer which sections it re-renders — names differ between theme versions. */
  function abschnitte() {
    var d = drawer();
    if (d && typeof d.getSectionsToRender === 'function') {
      try {
        return d.getSectionsToRender().map(function (s) { return s.id; });
      } catch (e) {
        console.error('LP-Direktkauf: getSectionsToRender fehlgeschlagen', e);
      }
    }
    return ['cart-drawer', 'cart-icon-bubble'];
  }

  function melden(kasten, text, istFehler) {
    var p = kasten.querySelector('[data-lp-meldung]');
    if (!p) return;
    p.textContent = text || '';
    p.classList.toggle('rd-meldung--fehler', !!istFehler);
  }

  function groessenZeigen(kasten, offen) {
    var knopf = kasten.querySelector('[data-lp-kauf-start]');
    var feld = kasten.querySelector('[data-lp-groessen]');
    if (knopf) knopf.setAttribute('aria-expanded', String(offen));
    if (feld) {
      feld.hidden = !offen;
      if (offen) {
        var erste = feld.querySelector('[data-lp-variante]:not([disabled])');
        if (erste) erste.focus({ preventScroll: true });
      }
    }
    if (!offen) melden(kasten, '');
  }

  function istOffen(kasten) {
    var feld = kasten.querySelector('[data-lp-groessen]');
    return !!feld && !feld.hidden;
  }

  function alleSchliessen(ausser) {
    for (var i = 0; i < kacheln.length; i++) {
      if (kacheln[i] !== ausser && istOffen(kacheln[i])) groessenZeigen(kacheln[i], false);
    }
  }

  async function inDenKorb(kasten, variantenId, knopf) {
    if (knopf) knopf.setAttribute('aria-busy', 'true');
    melden(kasten, '');

    try {
      var antwort = await fetch(wurzelPfad + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
        body: JSON.stringify({
          items: [{ id: Number(variantenId), quantity: 1 }],
          sections: abschnitte(),
          sections_url: window.location.pathname,
        }),
      });
      var daten = await antwort.json();

      // A size that sold out between page load and click comes back as 422 with a body
      // carrying `status` — it lands here, not in the catch.
      if (!antwort.ok || daten.status) {
        console.error('LP-Direktkauf: Shopify lehnt ab', antwort.status, daten && daten.description);
        melden(kasten, kasten.getAttribute('data-lp-fehler') || 'Leider vergriffen', true);
        return;
      }

      // Close first, then report: closing clears the message.
      groessenZeigen(kasten, false);
      melden(kasten, kasten.getAttribute('data-lp-gewaehlt') || 'Im Warenkorb', false);

      var d = drawer();
      if (d && typeof d.renderContents === 'function') {
        // Dawn marks an empty cart with `is-empty` on <cart-drawer> and hides the item list
        // with it. Its own product form removes the class before rendering; renderContents
        // does not. Without this line the FIRST add to an empty cart opened a drawer showing
        // the subtotal but no line item (measured 24.09.2026: item row in the DOM, 0 px tall).
        d.classList.remove('is-empty');
        d.renderContents(daten); // re-renders the cart AND opens the drawer
      } else {
        // No drawer to talk to: go to the cart instead of pretending nothing happened.
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        window.setTimeout(function () { window.location.href = wurzelPfad + 'cart'; }, 900);
      }
      window.setTimeout(function () { melden(kasten, ''); }, 4000);
    } catch (e) {
      console.error('LP-Direktkauf: Warenkorb-Anfrage fehlgeschlagen', e);
      melden(kasten, kasten.getAttribute('data-lp-fehler') || 'Leider vergriffen', true);
    } finally {
      if (knopf) knopf.removeAttribute('aria-busy');
    }
  }

  for (var i = 0; i < kacheln.length; i++) {
    (function (kasten) {
      var start = kasten.querySelector('[data-lp-kauf-start]');
      var einzeln = kasten.getAttribute('data-lp-einzeln');

      if (start) {
        start.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          if (einzeln) { inDenKorb(kasten, einzeln, start); return; }
          // The button toggles: a second tap closes the panel it opened.
          var offen = istOffen(kasten);
          alleSchliessen(kasten);
          groessenZeigen(kasten, !offen);
        });
      }

      var groessen = kasten.querySelectorAll('[data-lp-variante]');
      for (var g = 0; g < groessen.length; g++) {
        groessen[g].addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          if (this.hasAttribute('disabled')) return;
          inDenKorb(kasten, this.getAttribute('data-lp-variante'), this);
        });
      }

      var zu = kasten.querySelector('[data-lp-kauf-zu]');
      if (zu) {
        zu.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          groessenZeigen(kasten, false);
          if (start) start.focus({ preventScroll: true });
        });
      }
    })(kacheln[i]);
  }

  document.addEventListener('click', function (e) {
    if (!e.target.closest('[data-lp-kauf]')) alleSchliessen(null);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    for (var i = 0; i < kacheln.length; i++) {
      if (istOffen(kacheln[i])) {
        groessenZeigen(kacheln[i], false);
        var s = kacheln[i].querySelector('[data-lp-kauf-start]');
        if (s) s.focus({ preventScroll: true });
      }
    }
  });
})();
